<template>
  <div class="container dark-theme editor-wrapper"
    @mousemove="dragOver"
    @mouseup="dragEnd"
    v-if="$store.isLogin"
  >
    <file-side-bar class="sidebar-container" :fileItem.sync="fileItem"
      :style="{'width': treeWidth + 'px'}">
    </file-side-bar>
    <div class="drag-bar" @mousedown.stop="dragStart" :style="{left: treeWidth + 'px'}"></div>
    <!-- 根据选择的文件显示多 tab -->
    <file-tags class="file-container" :fileItem="fileItem" :bucketInfo.sync="bucketInfo"></file-tags>

    <!-- 各种操作失败弹窗 -->
    <failure-table :show.sync="dialogShow.failureTable"></failure-table>
  </div>
</template>

<script>
import fileSideBar from '@/components/desktop/editor/Sidebar/index.vue';
import fileTags from '@/components/desktop/editor/fileTags/index.vue';
import failureTable from '@/components/dialog/others/failureTable.vue';

import cos from '@/scripts/helper/cos';
import cosExpand from '@/scripts/helper/cos/cosExpand';
import storage from '@/scripts/tools/storage';

export default {
  components: {
    fileSideBar,
    fileTags,
    failureTable,
  },
  data() {
    return {
      fileItem: {},
      bucketInfo: {},
      draging: false,
      treeWidth: 300,
      minWidth: 300,

      dialogShow: {
        failureTable: false,
      },
    };
  },
  computed: {
    maxWidth() {
      return window.innerWidth - 300;
    },
  },
  mounted() {
    if (!this.$store.isLogin) return;

    this.handleRoute();
    // TODO: 清理 storage 里编辑器开关，未来将删除该处代码
    this.clearEditorMode();
    // 去掉文件路径，保留目录路径
    const { bucket, region, path = '' } = this.$route.query;
    const prefix = path.replace(/\/[^/]+$/, '/');
    if (path && !path.endsWith('/') && path !== prefix) {
      this.$router.replace({ path: this.$route.path, query: { bucket, region, path: prefix } });
    }
  },
  methods: {
    clearEditorMode() {
      const open = storage.get('openEditorMode');
      if (open) {
        storage.del('openEditorMode');
      }
    },
    handleRoute() {
      const { bucket, region, path = '' } = this.$route.query;
      const prefix = path.replace(/\/[^/]+$/, '/');
      const bucketInfo = { Bucket: bucket, Region: region, Prefix: prefix };
      cosExpand.getBucketPublicAcl(bucketInfo).then(ACL => {
        cos.getBucketWebsite(bucketInfo, (err, data) => {
          let Website = `${bucket}.cos-website.${region}.myqcloud.com`;
          if (err || data.statusCode === 404) {
            Website = '';
          }
          this.bucketInfo = { ...bucketInfo, ACL, Website };
        });
      });
    },
    dragStart($event) {
      this.draging = true;
      this.startPoint = $event.pageX;
    },
    dragOver($event) {
      if (!this.draging
          || this.treeWidth < this.minWidth
          || this.treeWidth > this.maxWidth
      ) {
        return;
      }
      const point = $event.pageX;
      this.treeWidth += point - this.startPoint;
      this.startPoint = point;
      if (this.treeWidth < this.minWidth) {
        this.treeWidth = this.minWidth;
      }
      if (this.treeWidth > this.maxWidth) {
        this.treeWidth = this.maxWidth;
      }
    },
    dragEnd() {
      this.draging = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.editor-wrapper {
  position: relative;
  overflow: auto;

  .sidebar-container {
    flex: none;
    min-width: 300px;
    display: flex;
    flex-direction: column;
  }
  .drag-bar {
    position: absolute;
    width: 5px;
    height: 100%;
    cursor: ew-resize;
  }
  .file-container{
    min-width: 300px;
  }
}

</style>
